import { getCmsConfirmationPopupContent } from "../../../app/api/getCmsConfirmationPopupContent";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse, ICmsConfirmationContent, ICmsContentData, IGetConfirmationContentActionParams } from "../../../Orchestrator/Types/Index";

class GetCmsConfirmationContentAction extends BaseAction<ICmsContentData[], IGetConfirmationContentActionParams> {
  override async run(): Promise<ICmsContentData[] | null> {
    let data: ICmsContentData[] = [];
    try {
      const { slug } = this.params!;
      const response: IApiResponse<ICmsConfirmationContent> = await getCmsConfirmationPopupContent(slug);
      
      if (response.status === "ok" && response.answer) {
        const responseData = response.answer.data;
        if (responseData.length > 0) {
          data = responseData;
          updateRecoilState("contentDetailAtom", responseData[0]);
        } else {
          console.warn("No destinations available.");
        }
      } else {
        console.warn("Failed to fetch destinations.");
      }
    } catch (error: any) {
      console.error("Error fetching destinations:", error);
    } finally {
      return data;
    }
  }
}

export const getCmsConfirmationContentAction = new GetCmsConfirmationContentAction();